import { abilitiesPlugin } from '@casl/vue';
import { roles } from './userData.js';
import { AbilityBuilder, Ability } from '@casl/ability';
const consola = createLogger(__filename);
export let ability;

// Init Ability
export default ({
  Vue
}) => {
  if (!roles) {
    consola.debug('Skip Casl boot');
    return;
  }
  consola.debug('Start Casl boot');
  const {
    rules,
    can
  } = new AbilityBuilder(Ability);

  // ограниченный админ - редактирование пользователей
  if (roles.includes('admin-user')) {
    can('read', 'admin-user');
  }

  // полный админ
  if (roles.includes('admin')) {
    can('manage', 'all');
  }
  ability = new Ability(rules);
  Vue.use(abilitiesPlugin, ability);
  consola.debug('End Casl boot');
};